import { createRootRouteWithContext } from "@tanstack/react-router";

import RootRoute from "@/components/Router/RootRoute";

import type { RouterContext } from "@/providers/routerConfig";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootRoute,
});
